import loadPageFragment from "./modules/loadPageFragment";
import { fadeFragment} from "./modules/loadPageFragment";
import announce from "./modules/announce";

function addOrRemoveFromShortlist({url, productId, addOrRemove, fragmentToRefresh, fragmentUrl, addFragmentPrefixToFragmentUrl, successCallback = ()=>{}}) {
  $.ajax(
    url,
    {
      method: 'POST',
      data: {
        productId: productId
      }
    }
  )
    .then(
      function success() {
        const callback = () => {
          if(addOrRemove === 'add') {
            announce("Product added to shortlist. Click the 'compare shortlisted products' button to compare.")
          } else {
            announce("Product removed from shortlist.")
          }

          updateBodyClass();
          successCallback();
        }

        loadPageFragment({
          url: fragmentUrl,
          targetFragmentId: fragmentToRefresh,
          scrollToTop: false,
          moveFocus: false,
          successCallback: callback,
          fallbackUrl: window.location,
          addFragmentPrefixToUrl: addFragmentPrefixToFragmentUrl
        });
      },

      function fail() {
        alert(`Sorry, there was a problem updating your shortlist`);
      }
    );
}

function updateBodyClass() {
  // Adds or removes a class on <body> depending on whether compare bar exists
  // Can be used to hide other floating elements in the same area like newsletter signup
  if($('.etl-ps-compare-bar').length > 0) {
    $('body').addClass('etl-ps-has-compare-bar')
  } else {
    $('body').removeClass('etl-ps-has-compare-bar')
  }
}

// 'Compare' tickboxes on products
$('body').on('change', '.etl-ps-compare-checkbox input[type=checkbox]', (e) => {
  const $form = $(e.target).closest('form');
  const addOrRemove = ($(e.target).prop('checked')) ? 'add' : 'remove';
  const addOrRemoveUrl = (addOrRemove === 'add') ? $form.attr('data-add-to-shortlist-url') : $form.attr('data-remove-from-shortlist-url');
  const productId = $form.find('input[name=productId]').val()

  addOrRemoveFromShortlist({
    url: addOrRemoveUrl,
    productId: productId,
    addOrRemove: addOrRemove,
    fragmentToRefresh: 'compare-bar',
    fragmentUrl: $('*[data-fragment-id="compare-bar"]').attr('data-fragment-url'),
    addFragmentPrefixToFragmentUrl: false
  })
})

// Change selection tickboxes on products in shortlist
$('body').on('change', '.etl-ps-shortlist-checkbox input[type=checkbox]', (e) => {
  const $form = $(e.target).closest('form');
  const url = $form.attr('action');
  const $checked = $form.find('input[type=checkbox]:checked');
  const toggledCheckboxValue = $(e.target).val();

  // If more than 4 checked, remove the first checked one that's not the one that was just toggled
  if($checked.length > 4) {
    $checked.not($(e.target)).last().prop('checked', false)
  }
  const productIds = $form.find('input[type=checkbox]:checked').toArray().map((c) => parseInt(c.value));

  // Fade the fragment now to prevent further interaction, otherwise it won't fade until the initial POST is complete
  fadeFragment('compare');

  $.ajax(
    url,
    {
      method: 'POST',
      processData: false,
      // We have to stringify productIds ourselves as Spring doesn't understand the productIds[]=1&productIds[]=2
      // format jQuery produces by default if we pass it an array
      data: (productIds.length > 0) ? `productIds=${productIds.join('&productIds=')}` : ''
    }
  )
    .then(
      function success() {
        const callback = () => {
          announce("Selection updated");
          // Refocus on the same checkbox
          $(`.etl-ps-shortlist-checkbox input[value=${toggledCheckboxValue}]`).focus();
        }

        loadPageFragment({
          url: window.location,
          targetFragmentId: 'compare',
          scrollToTop: false,
          moveFocus: false,
          successCallback: callback,
          fallbackUrl: window.location,
          addFragmentPrefixToUrl: true
        });
      },

      function fail() {
        alert(`Sorry, there was a problem updating your selected products`);
      }
    );
})

// 'Remove from shortlist' link buttons in compare bar
$('body').on('click', '.etl-ps-remove-from-shortlist-button--refresh-bar', (e) => {
  e.preventDefault();

  const $form = $(e.target).closest('form');
  const url = $form.attr('action');
  const productId = $form.find('input[name=productId]').val();

  // Find the index of this button amongst all the remove buttons in the bar, so we can focus on the button
  // with the same index when this product is removed
  const removeButtonSelector = '.etl-ps-remove-from-shortlist-button--refresh-bar';
  const buttonIndex = $(removeButtonSelector).index($(e.target));

  const callback = () => {
    // Untick the product in the list if it's ticked
    $(`#compare-${productId}`).prop('checked', false);

    focusRemoveButtonAtIndex(removeButtonSelector, buttonIndex);
  }

  addOrRemoveFromShortlist({
    url: url,
    productId: productId,
    addOrRemove: 'remove',
    fragmentToRefresh: 'compare-bar',
    fragmentUrl: $('*[data-fragment-id="compare-bar"]').attr('data-fragment-url'),
    addFragmentPrefixToFragmentUrl: false,
    successCallback: callback
  })
})

// 'Remove from shortlist' link buttons in shortlist at top of compare page
// Have to handle differently because they're not wrapped in a form (because there's already a form for the whole shortlist)
$('body').on('click', '.etl-ps-compare-bar__remove-link--shortlist', (e) => {
  const url = $(e.target).attr('data-remove-from-shortlist-url');
  const productId = $(e.target).attr('data-product-id');

  // Find the index of this button amongst all the remove buttons in the shortlist, so we can focus on the button
  // with the same index when this product is removed
  const removeButtonSelector = '.etl-ps-compare-bar__remove-link--shortlist';
  const buttonIndex = $(removeButtonSelector).index($(e.target));

  // Fade the fragment now to prevent further interaction, otherwise it won't fade until the initial POST is complete
  fadeFragment('compare');

  const callback = () => {
    focusRemoveButtonAtIndex(removeButtonSelector, buttonIndex);
  }

  addOrRemoveFromShortlist({
    url: url,
    productId: productId,
    addOrRemove: 'remove',
    fragmentToRefresh: 'compare',
    fragmentUrl: window.location,
    addFragmentPrefixToFragmentUrl: true,
    successCallback: callback
  })
})

// 'Remove from shortlist' link buttons in compare table
$('body').on('click', '.etl-ps-remove-from-shortlist-button--refresh-compare', (e) => {
  e.preventDefault();

  const $form = $(e.target).closest('form');
  const url = $form.attr('action');
  const productId = $form.find('input[name=productId]').val();

  // Find the index of this button amongst all the remove buttons in the table, so we can focus on the button
  // with the same index when this product is removed
  const removeButtonSelector = '.etl-ps-remove-from-shortlist-button--refresh-compare';
  const buttonIndex = $(removeButtonSelector).index($(e.target));

  // Fade the fragment now to prevent further interaction, otherwise it won't fade until the initial POST is complete
  fadeFragment('compare');

  const callback = () => {
    focusRemoveButtonAtIndex(removeButtonSelector, buttonIndex);
  }

  addOrRemoveFromShortlist({
    url: url,
    productId: productId,
    addOrRemove: 'remove',
    fragmentToRefresh: 'compare',
    fragmentUrl: window.location,
    addFragmentPrefixToFragmentUrl: true,
    successCallback: callback
  })
})

// Enable the expand/collapse comparison bar button
$('body').on('click', '.etl-ps-compare-bar__collapse-button', (e) => {
  const persistCollapseState = $(e.target).attr('data-persist-collapse-state') === 'true';

  if($(e.target).attr('aria-expanded') === 'false') {
    expandCompareBar();
    if(persistCollapseState) {
      localStorage.setItem('compareBarCollapsed', 'false');
    }
  } else {
    collapseCompareBar();
    if(persistCollapseState) {
      localStorage.setItem('compareBarCollapsed', 'true');
    }
  }
});

$(document).ready(() => {
  updateBodyClass();

  if(localStorage.getItem('compareBarCollapsed') === 'true' && $('.etl-ps-compare-bar__collapse-button').attr('data-persist-collapse-state') === 'true') {
    collapseCompareBar();
  }
});

function expandCompareBar() {
  $('.etl-ps-compare-bar__collapse-button').attr('aria-expanded', 'true');
  $('.etl-ps-compare-bar__collapse-button').addClass('etl-ps-compare-bar__collapse-button--expanded');
  $('.etl-ps-compare-bar__collapse-button-screen-reader-guidance').text('Hide shortlisted products');
  $('.etl-ps-compare-bar__products').addClass('etl-ps-compare-bar__products--visible');
}

function collapseCompareBar() {
  $('.etl-ps-compare-bar__collapse-button').attr('aria-expanded', 'false');
  $('.etl-ps-compare-bar__collapse-button').removeClass('etl-ps-compare-bar__collapse-button--expanded');
  $('.etl-ps-compare-bar__collapse-button-screen-reader-guidance').text('Show shortlisted products');
  $('.etl-ps-compare-bar__products').removeClass('etl-ps-compare-bar__products--visible');
}

function focusRemoveButtonAtIndex(removeButtonSelector, buttonIndex) {
  // Focus on the button with the same index as the one that was removed (or the last button, if the last product was removed)
  if($(removeButtonSelector).length-1 > buttonIndex) {
    $(removeButtonSelector).get(buttonIndex).focus();
  } else {
    $(removeButtonSelector).last().focus();
  }
}
